import { MuniSpinner2 } from "../../../../components";
import { useGeneralAppStore } from "../../../../store/generalAppStore";
import TrafficIcon from '@mui/icons-material/Traffic';
import TopInfracciones from "../TopInfracciones";
import { styled, Tooltip, tooltipClasses, Typography } from "@mui/material";
import React, { useEffect } from "react";
import MapaPuntoInfraccion from "./components/MapaPuntoInfraccion";
import { useEstadisticasStore } from "../../../../store/estadisticasStore";
import { getEstadisticasInfraccionesSemaforosHandler } from "../../../../handlers/estadisticasHandler";


const InfraccionesSemaforos = ({ estadisticas }) => {

    const { loads } = useGeneralAppStore();
    const { infracciones } = useEstadisticasStore();
    const HtmlTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: '#f5f5f9',
            color: 'rgba(0, 0, 0, 0.87)',
            maxWidth: 350,
            fontSize: theme.typography.pxToRem(14),
            border: '1px solid #dadde9',
        },
    }));
    useEffect(() => {
        if (!infracciones) {
            getEstadisticasInfraccionesSemaforosHandler();
        }
        return () => {
            useEstadisticasStore.setState({ infracciones: null })
        }
    }, [])
    // console.log(infracciones);

    return (
        <section className="py-5">
            <h4 className="text-center mb-0">Infracciones por semáforo</h4>
            <section className="d-flex">
                <div className="d-flex  flex-column align-items-center  py-4 col-6 mx-auto " >
                    <div className="d-flex justify-content-center gap-4 py-4 flex-wrap g-2 mt-2 mb-4  w-100 " style={{ height: "500px", overflowY: loads.includes('estadisticas') == false && "scroll" }}>
                        <>
                            {
                                loads.includes('estadisticas_semaforo') ?
                                    <div className="w-100 d-flex justify-content-center align-items-center" style={{ height: "450px" }}>
                                        <MuniSpinner2 />
                                    </div>
                                    :
                                    <>
                                        {
                                            infracciones?.infracciones.map((infraccion, index) => {
                                                return (

                                                    <div className=" d-flex flex-column align-items-center  justify-content-between" key={index} style={{ minHeight: "85px", width: "100px", cursor: "pointer" }}>
                                                        <HtmlTooltip
                                                            key={index}
                                                            arrow
                                                            // sx={{
                                                            //     "& .MuiTooltip-tooltip": {
                                                            //         minWidth:"200px",
                                                            //         maxWidth:"200px",
                                                            //         fontSize: "1rem",
                                                            //         backgroundColor: "#fff",  // Color de fondo blanco
                                                            //         color: "#333",             // Color de texto
                                                            //         border: "1px solid #ddd", // Opcional: agrega un borde para definir el tooltip
                                                            //         borderRadius: "4px",      // Opcional: redondear esquinas
                                                            //         boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.2)", // Opcional: sombra
                                                            //     },
                                                            //     "& .MuiTooltip-arrow": {
                                                            //         color: "#fff", // Color del borde del tooltip
                                                            //     }
                                                            // }}
                                                            title={
                                                                <div style={{ width: "270px", height: "300px" }} className="rounded">
                                                                    <div style={{ height: "15%" }} className="d-flex flex-column">
                                                                        <div className="d-flex gap-1">
                                                                            <span className="fw-bold text-primary">Lugar:</span>
                                                                            <span className="fw-bold ">{infraccion.lugar}</span>
                                                                        </div>
                                                                        <div className="d-flex gap-1">
                                                                            <span className="fw-bold text-primary">Infracciones:</span>
                                                                            <span className="fw-bold ">{infraccion.infracciones_count}</span>
                                                                        </div>
                                                                    </div>
                                                                    <MapaPuntoInfraccion latitud={infraccion?.latitud} longitud={infraccion.longitud} />
                                                                </div>
                                                            }
                                                        >
                                                            <div className="d-flex flex-column gap-1 align-items-center">
                                                                <div className="d-flex gap-1 justify-content-center w-100 align-items-center">
                                                                    {/* //! SVG despues pasarlo a un componente de icono */}
                                                                    {/* <SvgIcon
                                        sx={{ width: "25px", height: "25px" }}
                                        viewBox="0 0 24 24"
                                    >
                                        <defs>
                                            <linearGradient id="grad1" x1="0%" y1="0%" x2="0%" y2="100%">
                                                <stop offset="0%" style={{ stopColor: "#FFC107", stopOpacity: 1 }} />
                                                <stop offset="100%" style={{ stopColor: "#111", stopOpacity: 1 }} />
                                            </linearGradient>
                                        </defs>
                                        <TrafficIcon
                                            sx={{ width: "100%", height: "100%", fill: "url(#grad1)" }}
                                        />
                                    </SvgIcon> */}

                                                                    {/* <TrafficIcon sx={{ width: "25px", height: "25px", color: "#FFC107" }} /> */}
                                                                    <TrafficIcon sx={{ width: "25px", height: "25px", color: "#8C357A" }} />
                                                                    <h6 className="m-0 ">{infraccion.infracciones_count}</h6>

                                                                </div>
                                                                <p className="text-center m-0" style={{ fontSize: "12px" }}>{infraccion.lugar}</p>
                                                            </div>
                                                        </HtmlTooltip>
                                                    </div>

                                                )
                                            })
                                        }
                                    </>
                            }
                        </>
                    </div>
                </div>

                {(
                    infracciones && <div className="col-6">
                        <TopInfracciones estadisticas={infracciones?.infracciones?.slice(0, 10)} />
                    </div>
                )}
            </section>
        </section>
    );
}
export default InfraccionesSemaforos;